import  { useContext, useEffect, useState } from 'react'
import { useMutation } from 'react-query'

import { ContextType, verificationContext } from '../context/VerificationContext'
import { Typography, IconButton, List, Divider, ListItem, ListItemText } from '@mui/material'
import { familyHistorytableDataType } from '../Types/TableType'
import EditNoteIcon from '@mui/icons-material/EditNote';
import ErrorIcon from '@mui/icons-material/Error';
import usePopup from '../../../hooks/usePopup'
import { getFamilyHistoryData } from '../../../EMR/services'
import FamilyHistory from '../../../EMR/components/History/FamilyHistory/FamilyHistory'


function FamilyHistoryTable() {

const {CustomModal} = usePopup()
  const { searchData } = useContext(verificationContext) as ContextType
 const [open,setOpen] = useState<boolean>(false)
  const [tableData, setTableData] = useState<familyHistorytableDataType>({ totalCount: 0, items: [] })
  const { mutate: getFamilyhistoryDetails } = useMutation(getFamilyHistoryData,{onSuccess:(data)=>{setTableData((prev)=>({...prev,items:data.response}));
  }})
  useEffect(() => {
    if (searchData?.pmaster?.patientId) {
      getFamilyhistoryDetails(searchData?.pmaster?.id)
    }
  }, [searchData?.pmaster?.patientId])

const closepopUp=()=>{
  getFamilyhistoryDetails(searchData?.pmaster?.id as number)
  setOpen(false)
}

  return (
    <>
     <CustomModal  title='Family History' open={open} setOpen={setOpen} handleClose={()=>{closepopUp()}} >

<div className='max-h-[70dvh] w-[60vw]  p-2 overflow-auto' >
  <FamilyHistory/>
</div>
</CustomModal>

    

      <div className='flex  justify-between me-5'>
        <Typography className="!ml-2">
          <strong>Family History</strong>
        </Typography>
        <IconButton onClick={()=>{setOpen(true)}} edge="end" aria-label="delete">
          <EditNoteIcon color='primary'   />
        </IconButton>
      </div>
      <Divider />

      <List>
        {
          tableData?.items?.length > 0 ? (tableData?.items?.map((item:any) => {
            return (
              <>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={`${item?.icd?.icdCode}-(${item?.icd?.icdName})`}
                  />
                </ListItem>
                <Divider />
              </>
            )
          })) :
            <div className="col-span-12 flex justify-center items-center flex-col gap-2">
         
                <ErrorIcon color="info" sx={{ fontSize: "2rem" }} />
                No FamilyHistory found
              </div>
        
        }
      </List>
    </>
  )
}

export default FamilyHistoryTable
